// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","headingContent":"Header_headingContent__sfS6p","title":"Header_title__x3ga3","subtitle":"Header_subtitle__4RLMY"};